// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__19UFr"};